module.exports = __webpack_public_path__ + "img/MN.67b39abe.png";